if (!customElements.get('collection-featured-split-scroll')) {
  class CollectionFeaturedSplitScroll extends HTMLElement {
    constructor() {
      super();
      this.mediaQuery = window.matchMedia('(min-width: 750px)');
      this.boundOnBreakpointChange = this.onBreakpointChange.bind(this);
      this.boundSetViewportHeight = this.setViewportHeight.bind(this);
    }

    connectedCallback() {
      this.viewport = this.querySelector('[data-scroll-viewport]');
      this.list = this.querySelector('[data-products-list]');
      if (!this.viewport || !this.list) return;

      this.columns = Number(this.dataset.columns) || 3;
      this.visibleCount = Number(this.dataset.visibleCount) || 6;
      this.enableScroll = this.dataset.enableScroll === 'true';
      this.productCount = this.list.children.length;
      this.shouldScroll = this.enableScroll && this.productCount > this.visibleCount;

      if (!this.shouldScroll) return;

      this.mediaQuery.addEventListener('change', this.boundOnBreakpointChange);
      window.addEventListener('resize', this.boundSetViewportHeight);
      this.applyDesktopScrollState();

      this.list.querySelectorAll('img').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', this.boundSetViewportHeight, { once: true });
        }
      });
    }

    disconnectedCallback() {
      this.mediaQuery.removeEventListener('change', this.boundOnBreakpointChange);
      window.removeEventListener('resize', this.boundSetViewportHeight);
      this.clearViewportHeight();
      this.classList.remove('is-scrollable');
    }

    onBreakpointChange() {
      this.applyDesktopScrollState();
    }

    applyDesktopScrollState() {
      if (!this.shouldScroll) return;

      if (this.mediaQuery.matches) {
        this.classList.add('is-scrollable');
        requestAnimationFrame(() => this.setViewportHeight());
      } else {
        this.clearViewportHeight();
        this.classList.remove('is-scrollable');
      }
    }

    setViewportHeight() {
      if (!this.shouldScroll || !this.mediaQuery.matches) return;

      // Measure with unconstrained height so cards keep natural size
      this.viewport.style.maxHeight = 'none';

      const items = Array.from(this.list.children);
      if (!items.length) return;

      const styles = getComputedStyle(this.list);
      const rowGap = parseFloat(styles.rowGap) || 0;
      const rows = 2;

      let totalHeight = 0;
      for (let row = 0; row < rows; row++) {
        let rowHeight = 0;
        const start = row * this.columns;
        const end = Math.min(start + this.columns, items.length);
        if (start >= items.length) break;

        for (let i = start; i < end; i++) {
          rowHeight = Math.max(rowHeight, items[i].getBoundingClientRect().height);
        }
        totalHeight += rowHeight;
        if (row > 0) totalHeight += rowGap;
      }

      if (totalHeight > 0) {
        this.viewport.style.maxHeight = `${Math.ceil(totalHeight)}px`;
      }
    }

    clearViewportHeight() {
      if (this.viewport) {
        this.viewport.style.maxHeight = '';
        this.viewport.scrollTop = 0;
      }
    }
  }

  customElements.define('collection-featured-split-scroll', CollectionFeaturedSplitScroll);
}
